import { Validators } from '@angular/forms';
import { Injectable, TemplateRef } from '@angular/core';
import { BaseControl, Custom } from '@app/shared/dynamic-form';

@Injectable()
export class HeaderTitleTaskFormService {
  constructor() {}

  /**
   * Retorna los controles del formulario para iniciar secundarias
   *
   * @param {TemplateRef<any>} template
   * @returns {BaseControl<any>[]}
   * @memberof HeaderTitleTaskFormService
   */
  getFields(template: TemplateRef<any>): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboSecondary',
        label: 'Secundaria:',
        order: 1,
        value: null,
        template: template,
        placeholder: 'Seleccione la secundaria que desea iniciar.',
        validations: {
          validators: [Validators.required]
        }
      }),
    ];
    // Ordenar los campos segun su propiedad order
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/header-title-task/shared/header-title-task.form.service.ts